import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Contact", to: "/contact" },
  { label: "Mentions légales", to: "/mentions-legales" },
];

export default function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav
      data-testid="main-navigation"
      className="fixed top-0 left-0 right-0 z-50 bg-[#F8F6F2]/95 backdrop-blur-md border-b border-[#EEECE8]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col leading-tight" data-testid="logo-link">
            <span className="font-heading text-xl md:text-2xl font-black text-[#1B2E4B] tracking-tight">
              Bati Rui
            </span>
            <span className="text-[10px] md:text-xs font-medium text-[#C0392B] tracking-widest uppercase">
              Tous corps d'état
            </span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`nav-link-${link.to.replace("/", "") || "home"}`}
                className={`text-sm font-medium transition-colors hover:text-[#C0392B] ${
                  location.pathname === link.to
                    ? "text-[#C0392B]"
                    : "text-[#3D3D3A]"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="nav-cta-devis"
              className="bg-[#C0392B] hover:bg-[#a02f23] text-white rounded-md px-5 py-2.5 text-sm font-medium transition-colors"
            >
              Demander un devis
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 text-[#1B2E4B]"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#F8F6F2] border-t border-[#EEECE8] shadow-lg"
        >
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`block px-3 py-3 text-sm font-medium rounded-md transition-colors ${
                  location.pathname === link.to
                    ? "text-[#C0392B] bg-[#EEECE8]"
                    : "text-[#3D3D3A] hover:bg-[#EEECE8]"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="block mt-3 bg-[#C0392B] hover:bg-[#a02f23] text-white text-center rounded-md px-5 py-3 text-sm font-medium transition-colors"
            >
              Demander un devis
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
